export * from '@app/modules/landing/components/company/company.component';
export * from '@app/modules/landing/components/home/home.component';
export * from '@app/modules/landing/components/status/status.component';
export * from '@app/modules/landing/components/letter/letter.component';
export * from '@app/modules/landing/components/builder-register/builder-register.component';
